/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'repair': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M6.435 0v4.2c0 .6-3.678.6-3.678 0V0a4.596 4.596 0 00.39 8.574L1.875 14.4a2.832 2.832 0 000 1.2 2.784 2.784 0 105.436-1.2L6.04 8.562A4.596 4.596 0 006.435 0zM4.6 16.2a1.278 1.278 0 110-2.556 1.278 1.278 0 010 2.556zm10.998-6.6V4.8l.918-1.374a.972.972 0 00.096-.9L15.843.6a.972.972 0 00-.9-.6h-1.086a.972.972 0 00-.9.6l-.768 1.926a.972.972 0 00.096.9l.912 1.374v4.8a2.4 2.4 0 00-2.4 2.4v3.6a2.4 2.4 0 002.4 2.4h2.4a2.4 2.4 0 002.4-2.4V12a2.4 2.4 0 00-2.4-2.4z" _fill="#545E6D" fill-rule="nonzero"/>'
  }
})
